import React from 'react';
import { Controller, FieldValues } from 'react-hook-form';
import type { FormAvatarPickerProps } from './types';
import { AvatarPicker } from './AvatarPicker';

export function FormAvatarPicker<T extends FieldValues = FieldValues>({
  control,
  name,
  rules,
  helperText,
  ...props
}: FormAvatarPickerProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ 
        field: { onChange, value },
        fieldState: { error, invalid }
      }) => (
        <AvatarPicker
          {...props}
          value={value}
          onChange={onChange}
          error={invalid}
          helperText={error?.message || helperText}
        />
      )}
    />
  );
}

export default FormAvatarPicker;